import { useState, useEffect } from "react";
import AddTrainerModal from "../../../Pages/AddTrainerModal/AddTrainerModal";
import useDataStore from "../../../stores/useDataStore";
import { useTranslation } from "react-i18next";
import { BiPlusCircle } from "react-icons/bi";
import { toast } from "react-toastify";

export default function Trainers() {
    const [showModal, setShowModal] = useState(false);
    const [trainerToEdit, setTrainerToEdit] = useState(null);

    const { allTrainers, getAllTrainers, loading, error ,deleteTrainer  } = useDataStore();
    console.log(allTrainers);

    const { i18n } = useTranslation();
    const currentLang = i18n.language || 'ar';

    // عند تحميل الكومبوننت، نستدعي الدالة لجلب المدربين
    useEffect(() => {
        getAllTrainers();
    }, []);


    const handleEditTrainer = (trainer) => {
        setTrainerToEdit(trainer);
        setShowModal(true);
    };


// delete button 
      const showConfirmDeleteToast = (onConfirm, onCancel) => {
        toast(
          ({ closeToast }) => (
            <div className="p-4  ">
              <p className="font-bold text-lg">Are you sure you want to delete this Trainer?</p>
              <div className="flex justify-end mt-2 gap-2">
                <button
                  onClick={() => {
                    closeToast();
                    onCancel?.();
                  }}
                  className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400 text-sm"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    closeToast();
                    onConfirm?.();
                  }}
                  className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 text-sm"
                >
                  Confirm
                </button>
              </div>
            </div>
          ),
          {
            position: 'top-center',
            autoClose: false,
            closeOnClick: false,
            closeButton: false,
            draggable: false,
          }
        );
      };
    
      const handleDeleteClick = (trainerId) => {
        showConfirmDeleteToast(
          async () => {
            const success = await deleteTrainer(trainerId);
            if (success) {
              toast.success('Trainer deleted successfully!');
            } else {
              toast.error('Failed to delete the Trainer.');
            }
          },
          () => {
            console.log('Delete cancelled');
          }
        );
      };


    return (
        <div className="max-w-6xl mx-auto p-5 bg-gray-100 min-h-screen">
            <div className="flex justify-between items-center mb-4">
                <div>
                    <h1 className="text-2xl font-bold text-gray-900">Trainers</h1>
                    <p className="text-sm text-gray-600">Manage your platform trainers</p>
                </div>
                <button
                    onClick={() => setShowModal(true)}
                    className="bg-gray-900 hover:bg-gray-800 text-white px-4 py-2 rounded-md text-sm flex items-center"
                >
                    <BiPlusCircle className="mr-2 h-5 w-5" />
                    Add Trainer
                </button>

                {/* Modal */}
                {showModal && (
                    <AddTrainerModal open={showModal} onClose={() => { setShowModal(false); setTrainerToEdit(null); }} trainerToEdit={trainerToEdit} />
                )}
            </div>

            {loading && <p>Loading trainers...</p>}
            {error && <p className="text-red-500">{error}</p>}

<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
  {allTrainers.map((trainer) => (
    <div
      key={trainer._id}
      className="bg-white rounded-lg p-5 shadow-md flex flex-col justify-between"
    >
      {/* Trainer Image */}
      <img
        src={trainer.profileImage || "/placeholder.svg"}
        alt={trainer.name?.[currentLang] || "Trainer"}
        className="w-full h-40 object-cover rounded mb-4"
      />

      {/* Name and Courses */}
      <div className="text-center mb-3">
        <h2 className="text-lg font-bold text-gray-900">
          {trainer.name?.[currentLang] || "---"}
        </h2>
        <p className="text-sm text-gray-600">
          {trainer.courses} {trainer.courses === 1 ? "course" : "courses"}
        </p>
      </div>

      {/* Description */}
      <p className="text-sm text-gray-500 text-center mb-4">
        {trainer.description?.[currentLang] || "---"}
      </p>

      {/* Buttons */}
      <div className="flex flex-col sm:flex-row sm:flex-wrap lg:justify-center gap-3">
        <button className="w-full sm:w-auto flex-1 px-4 py-1 border border-gray-900 text-gray-900 rounded-md hover:bg-gray-100">
          View Profile
        </button>
        <button
          onClick={() => handleEditTrainer(trainer)}
          className="w-full sm:w-auto flex-1 px-4 py-1 bg-gray-900 text-white rounded-md hover:bg-gray-800"
        >
          Edit
        </button>
        <button
          onClick={() => handleDeleteClick(trainer._id)}
          className="w-full sm:w-auto flex-1 px-4 py-1 bg-red-100 text-red-700 rounded-md hover:bg-red-200"
        >
          Delete
        </button>
      </div>
    </div>
  ))}
</div>


        </div>
    );
}
